export { default } from './ProviderList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderList/index.js